import { IWykrojnikBase } from "../IWykrojnikBase";
import { IWykrojnikParams } from "./IWykrojnikParams";


export class WykrojnikParams {

    
    private static unflatten(p: IWykrojnikParams) {

        this.format_base(p.min);
        this.format_base(p.max);
        p.x1y1_korekta = parseFloat(<any>p.x1y1_korekta);

        return p;
    }

    public static format_base(ww: IWykrojnikBase) {
        const w = <any>ww;
        for (const k in w) {
            if (k != 'ksztalt') w[k] = Math.round(parseFloat(w[k]) * 1000) / 1000;
        }
        w.ux = parseInt(w.ux);
        w.uy = parseInt(w.uy);
        w.szerokosc = parseInt(w.szerokosc);
        w.zeby = parseInt(w.zeby);
        return w;
    }


    public static get_test_params(): IWykrojnikParams {

        const wp_test: IWykrojnikParams = {
          "ksztalt": "P",
          "x1y1_korekta": 0,
          "min": {
            "x": 70,
            "x1": 3.1,
            "y": 70,
            "y1": 3,
            "banda": 14,
            "ux": 1,
            "uy": 1,
            "szerokosc": 125,
            "zeby": 0,
            "R": 0
          },
          "max": {
            "x": 70,
            "x1": 430,
            "y": 70,
            "y1": 609.6,
            "banda": 430,
            "ux": 6,
            "uy": 9,
            "szerokosc": 430,
            "zeby": 192,
            "R": 0
          },
          "_id": "",
          "kalk_id": "27816",
          R:3, 
          szerokosci: [250, 235, 160, 125],
          zeby: [67, 70, 92, 116],
          banda_min:14,
          x:-1,
          y:-1,
          podklad:'PAPIER',
          grubosc_podkladu:0.55,
          tryb_eksperta:0,
          is_folia:1,
          szukaj_iml: 0,
          szukaj_papier: 0,
          szukaj_folia: 0,
          ignore_podklad: 1,
          nr_wykrojnika:""
      
        }
        return this.unflatten(wp_test);
        
      }
    

}

